const orderLineTypes = [
  'Purchase',
  'Rental',
  'Recurring',
];

export default orderLineTypes;



// WEBPACK FOOTER //
// ./src/config/orderLineTypes.js